import { render, staticRenderFns } from "./employee-form.vue?vue&type=template&id=e897169a"
import script from "./employee-form.vue?vue&type=script&lang=ts"
export * from "./employee-form.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports